import React, { useState } from "react";
import StatusPill from "../../../../components/data-table/StatusPill";
import RowActions from "../../../../components/data-table/RowActions";
import moment from "moment";

// components
import { useDeleteEventMutation } from "../../../../store/Reducer/events";
import DeleteModal from "../../../../components/confirm-dialog/delete-modal";
import MessageModal from "../../../../components/Modal/message-modal";

// What visitors see: drafts never; past one-off events have ended.
const STATUS = {
  draft: ["Draft", "gray"],
  hidden: ["Hidden", "gray"],
  upcoming: ["Published", "green"],
  ended: ["Ended", "red"],
};
const eventStatus = (e) => {
  if (!e?.isPublished) return "draft";
  if (e.isActive === false) return "hidden";
  if (e.type !== "Recurring" && e.date && moment().isAfter(e.date, "day")) return "ended";
  return "upcoming";
};

export default function TableBodyCustom({ data, index, onEditRow }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [messageModal, setMessageModal] = useState(false);

  const [deleteEvent, { isLoading: isDeleting }] = useDeleteEventMutation();

  const openModal = (id) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);
  const openMessageModal = () => setMessageModal(true);
  const closeMessageModal = () => setMessageModal(false);

  const handleDelete = async () => {
    if (selectedId) {
      try {
        await deleteEvent(selectedId).unwrap();
        closeModal();
      } catch (error) {
        console.error("Failed to delete news:", error);
      }
    }
  };

  const isRecurring = data?.type === "Recurring";
  const startdate = data?.date ? moment(data.date).format("ddd D MMM YYYY") : "";
  const status = eventStatus(data);

  return (
    <>
      <tr className="hover:bg-gray-50">
        <td className="px-4 py-3">
          <div className="flex items-center gap-3 max-md:flex-row-reverse">
            {data?.file?.url ? (
              <img src={data.file.url} alt="" className="h-10 w-14 shrink-0 rounded-md object-cover" />
            ) : (
              <span className="h-10 w-14 shrink-0 rounded-md bg-gray-100" aria-hidden="true" />
            )}
            <span className="font-medium text-gray-900">{data?.title}</span>
          </div>
        </td>
        <td className="px-4 py-3 max-w-xs">
          {data?.details ? (
            <button type="button" onClick={openMessageModal} className="line-clamp-2 text-left text-gray-600 hover:text-gray-900" title="Read the details">
              {data.details}
            </button>
          ) : (
            <span className="text-gray-400">—</span>
          )}
        </td>
        <td className="px-4 py-3 whitespace-nowrap">
          <span className="block text-gray-900">{isRecurring ? `Every ${(data?.recurringDays || []).join(", ")}` : startdate}</span>
          {data?.time && <span className="block text-xs text-gray-500">{moment(data.time, "HH:mm").format("h:mm a")}</span>}
        </td>
        <td className="px-4 py-3">
          <StatusPill tone={STATUS[status][1]}>{STATUS[status][0]}</StatusPill>
        </td>
        <td className="px-4 py-3">
          <RowActions onEdit={() => onEditRow(data)} onDelete={() => openModal(data?._id)} editLabel="Edit event" deleteLabel="Delete event" />
        </td>
      </tr>

      <DeleteModal
        isOpen={isOpen}
        title="Are You Sure?"
        desc="This action will remove the event."
        onConfirm={handleDelete}
        onCancel={closeModal}
        isLoading={isDeleting}
      />

      <MessageModal
        isOpen={messageModal}
        data={data?.details}
        title="Message"
        onConfirm={handleDelete}
        onCancel={closeMessageModal}
      />
    </>
  );
}
